/* Lazy playback for the mechanism clips.
 *
 * The <video> elements ship with preload="none" and no src, so four clips cost
 * nothing on first paint. The source is attached only once the row is near the
 * viewport, and playback pauses again when it scrolls away.
 *
 * load() is called explicitly after setting src: with preload="none" the element
 * has already settled into an idle network state, and relying on play() alone to
 * kick off the fetch is not reliable everywhere.
 *
 * data-src is the 480p rendition, derived in sections/oc-mechanism.liquid by
 * rewriting the quality slug in the URL Shopify hands the theme (Liquid only
 * ever exposes the LARGEST mp4). If that derived URL ever 404s -- Shopify
 * changing the slug, or a clip with no 480p rendition -- fall back once to
 * data-src-fallback, which is the untouched original, so a panel degrades to a
 * heavier video rather than to a blank plate.
 */
(function () {
  function boot() {
    var vids = document.querySelectorAll('[data-oc-video]:not([data-oc-vid-init])');
    if (!vids.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function attach(v, url) {
      v.src = url;
      v.load();
      var p = v.play();
      // Autoplay can be blocked; the poster frame stays and nothing is surfaced.
      if (p && p.catch) p.catch(function () {});
    }

    function activate(v) {
      if (v.dataset.ocVidLoaded) {
        var r = v.play();
        if (r && r.catch) r.catch(function () {});
        return;
      }
      v.dataset.ocVidLoaded = '1';
      attach(v, v.dataset.src);
    }

    Array.prototype.forEach.call(vids, function (v) {
      v.dataset.ocVidInit = '1';

      v.addEventListener('error', function () {
        var alt = v.dataset.srcFallback;
        if (!alt || v.dataset.ocVidFellBack || alt === v.dataset.src) return;
        v.dataset.ocVidFellBack = '1';
        attach(v, alt);
      });

      // Reduced motion keeps the poster and never fetches the clip.
      if (reduce) return;

      if (!('IntersectionObserver' in window)) {
        activate(v);
        return;
      }

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) activate(en.target);
            else if (en.target.dataset.ocVidLoaded) en.target.pause();
          });
        },
        { rootMargin: '200px 0px', threshold: 0.15 }
      ).observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
